<template>
  <div class="modal fade" :class="$props.class" tabindex="-1" ref="modal1">
    <div :class="dialogClass">

      <div class="modal-content">

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          :aria-label="$t('SUI.button.close')"
          :title="$t('SUI.button.close')" />

        <slot>MODAL CONTENT</slot>

      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';

export default defineComponent({
  name: 'StihlModal',
  emits: ['modalClosed'],
  props: {
    class: { type: String, default: null },
    dialogClass: { type: String, default: 'modal-dialog modal-dialog-centered' },
  },
  computed: {
    rootElem(): HTMLDivElement | undefined {
      return this.$refs.modal1 as HTMLDivElement;
    },
    modal(): Modal | undefined {
      return this.rootElem ? Modal.getOrCreateInstance(this.rootElem) : undefined;
    },
  },
  mounted() {
    console.debug('modal', 'mounted');
    this.modal?.show();
    this.rootElem?.addEventListener('hidden.bs.modal', () => this.$emit('modalClosed'));
  },
  beforeUnmount() {
    console.debug('modal', 'unmounting');
    this.modal?.hide(); // we need this to hide the overlay, when the modal is closed by router (ex: go back in history)
  },
});
</script>

<style scoped>
.modal {
  --bs-modal-border-radius: 0;
}
.modal .btn-close {
  position: absolute;
  top: 0;
  right: 0;

  --bs-btn-close-opacity: 1;
  --bs-btn-close-color: white;

  padding: .5rem;
}

.modal .btn-close:dir(rtl) {
  left:0;
  right: auto;
}

.modal .btn-close:hover {
  background-color: var(--orange-base, #F37A1F);
  transition: background-color .3s ease-out;
}

.modal-content {
  padding: var(--stihl-modal-content-padding, 3.5rem);
  gap: var(--stihl-modal-content-gap, 1rem);
}
</style>
